'use client';

import { c as _c } from "react/compiler-runtime";
import { useRenownAuth } from '@powerhousedao/reactor-browser';
import { AuthGuard } from '@/modules/shared/components/auth-guard';
import { useMyBuilderProfile } from '@/modules/shared/hooks/use-my-builder-profile';
import { LoginPrompt } from './login-prompt';
import { RequestForm } from './request-form';
import { SubmitRequestFormSkeleton } from './submit-request-form-skeleton';
function SubmitRequestForm() {
  const $ = _c(9);
  const {
    login
  } = useRenownAuth();
  const {
    drivesQuery,
    profileQuery,
    teamAdminDrive
  } = useMyBuilderProfile();
  const isResolving = drivesQuery.isLoading || profileQuery.isLoading;
  let t0;
  if ($[0] !== login) {
    t0 = <LoginPrompt onLogin={login} />;
    $[0] = login;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== isResolving || $[3] !== profileQuery || $[4] !== teamAdminDrive?.driveName) {
    t1 = isResolving ? <SubmitRequestFormSkeleton /> : <RequestForm defaultName={profileQuery.data?.name ?? ""} defaultTeamName={teamAdminDrive?.driveName ?? ""} />;
    $[2] = isResolving;
    $[3] = profileQuery;
    $[4] = teamAdminDrive?.driveName;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t0 || $[7] !== t1) {
    t2 = <AuthGuard loginFallback={t0}>{t1}</AuthGuard>;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
export { SubmitRequestForm };